import React from "react";

/**
 * Soft status pill for manage tables (matches Advertisements style).
 */
export const renderStatusBadge = (item) => {
  let label = "-";
  if (item?.status !== undefined && item?.status !== null && item.status !== "") {
    label = String(item.status);
  } else if (item?.isActive !== undefined) {
    label = item.isActive ? "Active" : "Inactive";
  }

  if (label === "-" || !label) {
    return <span className="text-muted">—</span>;
  }

  const normalized = label.trim().toLowerCase();
  let tone = "secondary";
  if (
    normalized === "active" ||
    normalized === "published" ||
    normalized === "yes" ||
    normalized === "default"
  ) {
    tone = "success";
  } else if (
    normalized === "inactive" ||
    normalized === "unpublished" ||
    normalized === "expired" ||
    normalized === "no"
  ) {
    tone = "danger";
  } else if (normalized === "draft" || normalized === "pending" || normalized === "upcoming") {
    tone = "warning";
  }

  return <span className={`badge badge-soft-${tone}`}>{label}</span>;
};

export const renderSoftBadge = (label, tone = "secondary") => (
  <span className={`badge badge-soft-${tone}`}>{label}</span>
);
